import React from 'react';
import type { PositionedShift } from '../../lib/shiftOverlay';

/** Soft shift bands + tiny labels behind Load curve / Bookings. */
export function ShiftOverlay({
  shifts,
  y0,
  y1,
  showLabels = true,
  labelY,
}: {
  shifts: PositionedShift[];
  y0: number;
  y1: number;
  showLabels?: boolean;
  /** Baseline for the label (defaults near y0). */
  labelY?: number;
}) {
  if (!shifts.length) return null;
  const textY = labelY ?? y0 + 10;
  const h = Math.max(0, y1 - y0);
  return (
    <g className="rib-shifts" aria-hidden>
      {shifts.map((s, i) => (
        <g key={s.id}>
          <rect
            className={`rib-shift-band${i % 2 === 0 ? ' even' : ' odd'}`}
            x={s.x1}
            y={y0}
            width={s.x2 - s.x1}
            height={h}
          />
          <line
            className="rib-shift-edge"
            x1={s.x1}
            x2={s.x1}
            y1={y0}
            y2={y1}
          />
          {i === shifts.length - 1 && (
            <line
              className="rib-shift-edge"
              x1={s.x2}
              x2={s.x2}
              y1={y0}
              y2={y1}
            />
          )}
          {showLabels && s.x2 - s.x1 > 36 && (
            <text
              className="rib-shift-lab"
              x={(s.x1 + s.x2) / 2}
              y={textY}
              textAnchor="middle"
            >
              {s.name}
            </text>
          )}
        </g>
      ))}
    </g>
  );
}
